import { render } from "./trust_badges.vue?vue&type=template&id=e5b083e0"
import script from "./trust_badges.vue?vue&type=script&lang=js"
export * from "./trust_badges.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__